import { render, staticRenderFns } from "./PointMonitor.vue?vue&type=template&id=4d824777&scoped=true&"
import script from "./PointMonitor.vue?vue&type=script&lang=js&"
export * from "./PointMonitor.vue?vue&type=script&lang=js&"
import style0 from "./PointMonitor.vue?vue&type=style&index=0&id=4d824777&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d824777",
  null
  
)

export default component.exports